// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "serviceWrapper__segmentTabsMeal-3HrM8";
var _5 = "serviceWrapper__meal-Ngoui";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "mobile", _4 as "serviceWrapper__segmentTabsMeal", _5 as "serviceWrapper__meal" }
export default { "__esModule": _1, "desktop_only": _2, "mobile": _3, "serviceWrapper__segmentTabsMeal": _4, "serviceWrapper__meal": _5 }
